import "./index.css";

import NiceModal from "@ebay/nice-modal-react";
import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import ReactModal from "react-modal";
import { HashRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";

import Loading from "components/Loading";
import SimpleModal from "components/modals/SimpleModal";
import { TErrCodes } from "types/types";
import { DEFAULT_MESSAGE_ERROR } from "utils/const";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

ReactModal.setAppElement("#root");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: false,
    },
  },
  queryCache: new QueryCache({
    onError: queryCacheOnError,
  }),
  mutationCache: new MutationCache({
    onError: mutationCacheOnError,
  }),
});

function queryCacheOnError(err: any, query: any) {
  switch (query.meta?.errCode) {
    case TErrCodes.NONE:
      return;
    default:
      NiceModal.show(SimpleModal, {
        title: "알림",
        message: err?.response?.data?.errMsg ?? DEFAULT_MESSAGE_ERROR,
        showCancel: false,
      });
  }
}

function mutationCacheOnError(
  err: any,
  _variables: any,
  _context: any,
  mutation: any,
) {
  queryCacheOnError(err, mutation);
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <HashRouter>
      <RecoilRoot>
        <QueryClientProvider client={queryClient}>
          <NiceModal.Provider>
            <App />
            <Loading />
          </NiceModal.Provider>
        </QueryClientProvider>
      </RecoilRoot>
    </HashRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
